import { ActionReducerMap } from '@ngrx/store';
import * as fromExtras from './extras.reducer';
import * as fromProtection from './protection.reducer';
import * as fromDeclineProtection from './decline.protection.reducer';
import * as fromTermsConditions from './terms.conditions.reducer';
import * as fromItemOffer from './item.offer.reducer';
export interface AdditionalServicesState {
  readonly extras: fromExtras.ExtrasState;
  readonly protection: fromProtection.ProtectionState;
  readonly declineProtection: fromDeclineProtection.DeclineProtectionState;
  readonly terms: fromTermsConditions.TermsConditionsState;
  readonly itemOffer: fromItemOffer.ItemOfferState;
}

export const additionalServicesReducers: ActionReducerMap<AdditionalServicesState> =
  {
    extras: fromExtras.reducer,
    protection: fromProtection.reducer,
    declineProtection: fromDeclineProtection.reducer,
    terms: fromTermsConditions.reducer,
    itemOffer: fromItemOffer.reducer,
  };

export const ADDITIONAL_SERVICES_FEATURE = 'additionalServices';
